"use client";

import { getBarDelFeeById } from "@/app/_lib/data/transtportFeeQueries";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

const calculateSubTotal = (cartState) => {
  if (!Array.isArray(cartState) || cartState.length === 0) return 0;

  const total = cartState.reduce((sum, item) => {
    const price = Number(item.sellingPrice) || 0;
    const qty = Number(item.quantity) || 0;

    return sum + price * qty;
  }, 0);
  // console.log(total);
  // return total;
  return total;
};

const computeTotal = (s) =>
  (s.subTotal ?? 0) +
  (s.shippingFee ?? 0) +
  (s.taxes ?? 0) -
  (s.couponDiscount ?? 0);

export const fetchShippingFee = createAsyncThunk(
  "checkout/shippngFee",
  async ({ barangayId, type }, { rejectWithValue }) => {
    try {
      const data = await getBarDelFeeById(barangayId);

      if (!data) return rejectWithValue("No fee found for this barangay");
      console.log(type);
      return type === "store" ? data.base_fee : data.pasabuy_fee;
    } catch (err) {
      return rejectWithValue(err?.message || "Failed to fetch shipping fee");
    }
  }
);

let initialState = {
  location: {},
  branchId: null,
  cartItems: [],
  currentItemClickedBuy: [],
  customerName: "",
  customerId: null,
  phoneNumber: null,
  municipalId: 1,
  barangayId: "",
  instructions: "",
  subTotal: 0,
  shippingFee: null,
  shippingLoading: false,
  shippingError: null,
  taxes: 0,
  couponDiscount: 0,
  total: 0,
  onEditModeName: false,
  onEditModeAddress: false,
  barangayName: "",
  municipalName: "Molave",
};

const customerCartSlice = createSlice({
  name: "customerCart",
  initialState,
  reducers: {
    calculateTotal(state) {
      state.total =
        state.subTotal + state.shippingFee + state.taxes - state.couponDiscount;
    },

    setCustomerCoordinates(state, action) {
      state.location = action.payload;
    },
    setCustomerAddress(state, action) {
      state.address = action.payload;
    },

    addCartItem(state, action) {
      const incoming = action.payload;
      const idx = state.cartItems.findIndex(
        (i) => i.branchProductId === incoming.branchProductId
      );

      if (idx === -1) {
        state.cartItems = [
          ...state.cartItems,
          {
            ...incoming,
            quantity: incoming.quantity ?? 1,
            itemSubTotal: incoming.itemSubTotal,
          },
        ];
      } else {
        // If product already exist just add 1 to its current quantity and update subttotal

        const current = state.cartItems[idx];
        const next = [
          ...state.cartItems.slice(0, idx),
          {
            ...current,
            quantity: (current.quantity ?? 1) + (incoming.quantity ?? 1),
            itemSubTotal: incoming.itemSubTotal,
          },
          ...state.cartItems.slice(1 + idx),
        ];
        state.cartItems = next;
      }
      state.subTotal = calculateSubTotal(state.cartItems);
      state.total = computeTotal(state);
    },

    setBranchId(state, action) {
      state.branchId = action.payload;
    },

    setCurrentItemClickedBuy(state, action) {
      state.currentItemClickedBuy = action.payload;
      state.cartItems = state.cartItems.map((prod) => {
        if (prod.branchProductId !== action.payload) {
          return { ...prod, checked: false };
        } else {
          return prod;
        }
      });
    },

    modifyCustomerCartItem(state, action) {
      const { branchProductId, quantity, itemSubTotal } = action.payload;
      state.cartItems = state.cartItems.map((prod) => {
        if (prod.branchProductId === branchProductId) {
          return { ...prod, quantity, itemSubTotal };
        } else {
          return prod;
        }
      });

      state.subTotal = calculateSubTotal(state.cartItems);
      state.total = computeTotal(state);
    },

    setShippingFee(state, action) {
      state.shippingFee = action.payload;
      state.total = computeTotal(state);
    },

    setShippingLoading(state, action) {
      state.shippingLoading = action.payload;
    },

    setPersonalInformation(state, action) {
      state.customerId = action.payload.customerId;
      state.phoneNumber = action.payload.phone;
      state.customerName = action.payload.fullName;
    },

    setPersonalAddressInformation(state, action) {
      state.municipalId = action.payload.municipalId;
      state.barangayId = action.payload.barangayId;
      state.instructions = action.payload.instructions;
      state.barangayName = action.payload.barangayName;
    },

    removeItemFromCustomerCart(state, action) {
      state.cartItems = state.cartItems.filter((item) => {
        return item.branchProductId !== action.payload;
      });

      state.subTotal = calculateSubTotal(state.cartItems);
      state.total = computeTotal(state);
    },

    setMunicipalName(state, action) {
      state.municipalName = action.payload;
    },

    setBarangayName(state, action) {
      state.barangayName = action.payload;
    },

    setOnEditModeName(state, action) {
      state.onEditModeName = action.payload;
    },

    setOnEditModeAddress(state, action) {
      state.onEditModeAddress = action.payload;
    },

    resetCustomerCartState(state, action) {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchShippingFee.pending, (state) => {
        state.shippingLoading = true;
        state.shippingError = null;
      })
      .addCase(fetchShippingFee.fulfilled, (state, action) => {
        state.shippingLoading = false;
        state.shippingFee = action.payload;
        state.total = computeTotal(state);
      })
      .addCase(fetchShippingFee.rejected, (state, action) => {
        state.shippingLoading = false;
        state.shippingError = action.payload ?? action.error.message;
      });
  },
});

export const {
  addCartItem,
  resetCustomerCartState,
  setCurrentItemClickedBuy,
  removeItemFromCustomerCart,
  modifyCustomerCartItem,
  setShippingLoading,
  setShippingFee,
  setPersonalAddressInformation,
  setPersonalInformation,
  setBranchId,
  setOnEditModeName,
  setOnEditModeAddress,
  setCustomerAddress,
  setCustomerCoordinates,
  setMunicipalName,
  setBarangayName,
} = customerCartSlice.actions;

export default customerCartSlice.reducer;
